import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-changeable-image',
    templateUrl: './changeable-image.component.html',
    styleUrls: ['./changeable-image.component.scss'],
    standalone: false
})
export class ChangeableImageComponent implements OnInit {
  @Input() defaultImageUrl!: string;
  @Input() iconImageUrl!: string;
  @Input() rotation: string = "0";

  @Output() imageFileSelected:EventEmitter<File>;

  @ViewChild("fileInput") private fileInputElement!: ElementRef<HTMLInputElement>;

  protected displayedImageUrl!: string | SafeUrl;

  protected acceptableFileTypes: Array<string> = [ "image/jpg", "image/jpeg", "image/png","image/webp" ];

  constructor(
    private sanitizer: DomSanitizer
  ) {
    this.imageFileSelected = new EventEmitter<File>();
  }

  public ngOnInit(): void {
    this.displayedImageUrl = this.defaultImageUrl;
  }

  /**
   * If a file is selected, check if it has an acceptable type (image), update the displayed image
   * and emit an `imageFileSelected` event.
   */
  @HostListener('change', ['$event.target.files']) emitFiles(event: FileList) {
    const file: File | null = event && event.item(0);

    // Check if a file is selected and it is from the allowed types
    if (!file || this.isFileTypeAllowed(file) == false) {
      return;
    }

    // Create an URL from the file to display it
    this.displayedImageUrl = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file));

    // Emit the newly selected file
    this.imageFileSelected.emit(file);
  }

  protected onSelectImageButtonClick(): void {
    this.fileInputElement.nativeElement.click();
  }

   /**
   * Checks whether the file type is acceptable.
   *
   * @param file the file
   * @returns boolean that indicates if the file is allowed
   */
   private isFileTypeAllowed(file: File): boolean {
    return this.acceptableFileTypes.includes(file.type);
  }

}
